import { levenshteinDistance } from './levenshtein-distance.js';

type Suggestion = {
  word: string;
  distance: number;
};

class SuggestionList {
  private readonly suggestions: Suggestion[] = [];

  addMatch(word: string, distance: number) {
    if (this.suggestions.length === 3) {
      if (this.suggestions[2].distance < distance) {
        return; // No need to add if the new match is not closer than the worst match
      }
      this.suggestions.pop(); // Remove the worst match to make space for the new one
    }
    this.suggestions.push({ word, distance });
    this.suggestions.sort((a, b) => a.distance - b.distance);
  }

  toArray(): string[] {
    return this.suggestions.map(match => match.word);
  }
}

export type ValidWordValidation = {
  ok: true;
};
export type InvalidWordValidation = {
  ok: false;
  error?: string;
  suggestions?: string[];
};
export type WordListValidation = ValidWordValidation | InvalidWordValidation;

export class WordList {
  constructor(private readonly words: string[]) {
  }

  toArray(): string[] {
    return [...this.words];
  }

  validate(word: string): WordListValidation {
    if (this.words.includes(word)) {
      return { ok: true } as const;
    }

    const suggestions = this.suggestions(word);
    if (suggestions.length) {
      return { ok: false, suggestions } as const;
    }
    return { ok: false, error: 'not found' };
  }

  private suggestions(word: string) {
    const suggestions = new SuggestionList();
    for (const item of this.words) {
      const distance = levenshteinDistance(word, item);
      // Skip words that are too far away
      if (distance > 3) {
        continue;
      }

      suggestions.addMatch(item, distance);
    }
    return suggestions.toArray();
  }
}
